import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.monitoringApiUrl;
const setupURI = config.setupApiUrl;
const prnrURI = config.companyApiUrl;

const reportStoreModule = {
  // namespaced: false,

  state: {
    reportList: [],
    dataSet01Source: [],
    totalReportCnt: null,
  },
  mutations: {
    'SET_STORE_REPORT'(state, report) {
      state.reportList = report;
      state.dataSet01Source = report.data;
    },
    'SET_STORE_TOTAL_REPORT_CNT'(state, trsDataCnt) {
      state.totalReportCnt = trsDataCnt;
    },
    'SET_STORE_REPORT_FILTER'(state, filter) {
      let report = state.dataSet01Source;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = report;
        }
        listResult = report.filter(item => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
          return false;
        });
      }
      state.reportList = listResult;
    }
  },
  actions: {
    getReportList: async ({ commit, state }, params) => {

      /**
       https://albdev.smartlink-platform.com:3200/report?filter=(dateTime BETWEEN '2021-12-19' AND '2021-12-22') AND direction eq 'I'&orderBy=dateTime desc
       Owner : https://albdev.smartlink-platform.com:3200/report/users/cyberlogitec.com
       Company : https://albdev.smartlink-platform.com:3200/report/users/cyberlogitec.com/binexline.com
      **/
      let url = `${baseURI}/report/users/`;
      let filterPrnr = false;
      // Ownr
      if (params.ownrId === params.groupId) {
        url += `${params.ownrId}`;
        if (params.company) {
          url += `/${params.company}`;
        }
      }
      // Company
      else {
        filterPrnr = true;
        url += `${params.ownrId}/${params.groupId}`;
      }

      let filterparms = "";

      if (params.dateCond) {
        filterparms = `(dateTime BETWEEN '${params.fromDateData}' AND '${params.toDateData}')`;
      }
      if (params.senderId !== '') {
        if (params.dateCond) filterparms += ` AND `;
        filterparms += `senderId like '${params.senderId}'`;
      }
      if (params.recipientId !== '') {
        if (params.dateCond || params.senderId !== '') filterparms += ` AND `;
        filterparms += `recipientId like '${params.recipientId}'`;
      }
      if (params.message !== '') {
        if (params.dateCond || params.senderId !== ''
          || params.recipientId !== '') filterparms += ` AND `;
        filterparms += `(messageName eq '${params.message}')`;
      }

      if (params.direction) {
        filterparms += ` AND direction eq '${params.direction}'`;
      }

      if (params.dateCond || params.senderId !== ''
        || params.recipientId !== '' || params.message !== '') filterparms += `&`;
      filterparms += `orderBy=dateTime desc`;
      // if (params.page != '') {
      //   filterparms += `&page=${params.page}`;
      // }
      // if (params.perPage != '') {
      //   filterparms += `&perPage=${params.perPage}`;
      // }

      let filter = "";
      if (params.dateCond || params.senderId !== ''
        || params.recipientId !== '' || params.message !== ''
      ) filter = `filter=${filterparms}`;
      else filter = filterparms;
      url = url + '?' + filter;

      console.log("url : " + url);
      await axios.get(url).then(async (response) => {

        // console.log("response : " + JSON.stringify(response));

        let trsData2 = [];
        let trsDataCnt = 0;

        if (response.data == "No Results Found") {
          response.data = [];
        } else {

          const response_proc = await axios.post(`${setupURI}/process/list/fortransaction`, params);
          const response_prnr = await axios.post(`${prnrURI}/partner/list`, params);

          const trsData = response.data.data;
          trsDataCnt = response.data.totalCnt;
          const procData = response_proc.data;
          const prnrData = response_prnr.data;

          for (let i = 0; trsData.length > i; i += 1) {
            for (let j = 0; procData.length > j; j += 1) {
              // 2021.9.17 203728 processSetupId-version
              if (trsData[i].processSetupId.includes(procData[j].processSetupId)) {

                trsData[i].processSetupName = procData[j].processSetupName;
                trsData[i].partnerId = procData[j].partnerId;
                trsData[i].direction = procData[j].direction;

                if (trsData[i].partnerId !== '') {
                  for (let k = 0; prnrData.length > k; k += 1) {
                    if (trsData[i].partnerId === prnrData[k].prnrId) {
                      trsData[i].partnerName = prnrData[k].prnrNm
                    }
                  }
                }
                break;
              }
            }
          }

          let m = 0;
          // if (params.messageDirection !== '') {
          //   if (params.partner !== '') {
          //     for (let k = 0; trsData.length > k; k += 1) {
          //       if (params.messageDirection === trsData[k].direction && params.partner === trsData[k].partnerId) {
          //         trsData2[m] = trsData[k];
          //         m++;
          //       }
          //     }
          //   } else {
          //     for (let k = 0; trsData.length > k; k += 1) {
          //       if (params.messageDirection === trsData[k].direction) {
          //         trsData2[m] = trsData[k];
          //         m++;
          //       }
          //     }
          //   }
          //   trsDataCnt = trsData2.length;
          // } else {
          if (filterPrnr && params.prnrId) {
            for (let k = 0; trsData.length > k; k += 1) {
              if (params.prnrId === trsData[k].partnerId) {
                trsData2[m] = trsData[k];
                m++;
              }
            }
            trsDataCnt = trsData2.length;
          } else {
            trsData2 = trsData;
          }
          // }
        }

        let totalGroup = {
          received_count_total: 0,
          sent_count_total: 0,
          successCount: 0,
          failCount: 0,
          inputFileSize: 0,
          outputFileSize: 0,
          totalCount: 0
        }

        let groupRecord = [];

        trsData2.map(e => {
          if (!e.partnerId) {
            e.partnerId = "unknown";
            e.partnerName = "Unknown";
          }
          if (e.partnerId === "*") {
            e.partnerName = "*";
          }
          if (!groupRecord[filterPrnr ? e.partnerId : e.userId]) groupRecord[filterPrnr ? e.partnerId : e.userId] = {
            received_count_total: 0,
            sent_count_total: 0,
            successCount: 0,
            failCount: 0,
            inputFileSize: 0,
            outputFileSize: 0,
            totalCount: 0,
            name: e.partnerName,
            id: filterPrnr ? e.partnerId : e.userId
          };

          // Total of group
          // groupRecord[e.partnerId].received_count_total += e.received_count_total;
          // groupRecord[e.partnerId].sent_count_total += e.sent_count_total;
          groupRecord[filterPrnr ? e.partnerId : e.userId].successCount += e.successCount;
          groupRecord[filterPrnr ? e.partnerId : e.userId].failCount += e.failCount;
          groupRecord[filterPrnr ? e.partnerId : e.userId].inputFileSize += e.inputFileSize;
          groupRecord[filterPrnr ? e.partnerId : e.userId].outputFileSize += e.outputFileSize;
          groupRecord[filterPrnr ? e.partnerId : e.userId].totalCount += e.totalCount;

          // Total
          // totalGroup.received_count_total += e.received_count_total;
          // totalGroup.sent_count_total += e.sent_count_total;
          totalGroup.successCount += e.successCount;
          totalGroup.failCount += e.failCount;
          totalGroup.inputFileSize += e.inputFileSize;
          totalGroup.outputFileSize += e.outputFileSize;
          totalGroup.totalCount += e.totalCount;
        })

        // console.log("transactionData : " + JSON.stringify(trsData2));
        commit('SET_STORE_REPORT', { data: trsData2, groupData: groupRecord, totalData: totalGroup });
        commit('SET_STORE_TOTAL_REPORT_CNT', trsDataCnt);
      }).catch((ex) => {
        console.log(ex);
        throw ex;
      });
    },
  },
  getters: {
    reportList: state => state.reportList,
    totalReportCnt: state => state.totalReportCnt,
  },
};

export default reportStoreModule;
